import context from '@/context'

const menu = normalize(context.menuContent)
const activeItemId = getItemId(menu, window.location.pathname)
const activePath = getPath(menu, activeItemId)
const initialState = {
  items: menu,
  openPath: [],
  activePath: activePath,
  isNavSmall: false
}

function normalize (menu) {
  const items = []

  function flatten (parent, children, depth) {
    if (children && children.length) {
      children.forEach((ch, i) => {
        items.push(ch)
        if (!ch.id) ch.id = `${(parent && parent.id) || ''}_${i}`
        ch.depth = depth
        if (ch.subMenuItems && ch.subMenuItems.length) {
          flatten(ch, ch.subMenuItems, depth + 1)
          delete ch.subMenuItems
          ch.hasChildren = true
        }
        if (parent) {
          ch.parentId = parent.id
        }
      })
    }
  }

  flatten(null, menu, 0)
  return items
}

function getItemId (items, url) {
  const item = items.find(x => url.startsWith(x.path))
  return item && item.id
}

function getPath (items, itemId) {
  const path = []
  while (itemId) {
    const item = itemId ? items.find(x => x.id === itemId) : null
    if (item) {
      path.unshift(item.id)
      itemId = item.parentId
    } else {
      break
    }
  }
  return path
}

const actionTypes = {
  setActiveItem: 'menu/setActiveItem',
  setOpenItem: 'menu/setOpenItem',
  compactToggle: 'menu/compactToggle'
}

const actionCreators = {
  setActiveItem: (id) => (
    { type: actionTypes.setActiveItem, id }
  ),
  setOpenItem: id => (
    { type: actionTypes.setOpenItem, id }
  ),
  compactToggle: () => (
    { type: actionTypes.compactToggle }
  )
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.compactToggle: {
      return { ...state, isNavSmall: !state.isNavSmall }
    }
    case actionTypes.setActiveItem: {
      const path = getPath(state.items, action.id)
      return { ...state, activePath: path, openPath: [] }
    }
    case actionTypes.setOpenItem: {
      const path = getPath(state.items, action.id)
      return { ...state, openPath: path }
    }
    case 'identity:userFound': {
      try {
        const items = JSON.parse(action.user.profile.settings.customizedMenuItems || '{}')
        return { ...state, items: [...state.items.map(item => updateMenuItem(item, items))] }
      } catch (err) {
        console.log(err)
      }
      return state
    }
    case '@@router/LOCATION_CHANGE': {
      const id = getItemId(state.items, action.payload.pathname)
      const path = getPath(state.items, id)
      return { ...state, activePath: path, openPath: [] }
    }
    default:
      return state
  }
}

export function updateMenuItem (item, items) {
  let changes = items[item.id]
  if (changes) {
    if (typeof changes === 'string') {
      changes = { path: changes }
    }
    return { ...item, ...changes }
  }
  return item
}

export {
  reducer,
  actionCreators,
  actionTypes,
  initialState
}



// WEBPACK FOOTER //
// ./src/store/Menu.js